import { Box, Container, Typography } from '@mui/material';
import { Loader, usePartners, SimpleList } from '@shared';
import { RouteEnum, useGotoRoute } from 'App/routes';

export function Partners() {
  const { data, isError, isLoading } = usePartners(true);
  const goToRoute = useGotoRoute(RouteEnum.Courses);

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return null;
  }

  return (
    <Container component='article'>
      <SimpleList
        title='All partners'
        entityName={'partner'}
        rows={data}
        onRowClick={goToRoute}
        renderElems={({ name }) => (
          <Box sx={{ p: 2 }}>
            <Typography variant='tableCell'>{name}</Typography>
          </Box>
        )}
      />
    </Container>
  );
}
